module.exports = __webpack_public_path__ + "img/call.426456b4.svg";